import { Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { postingTemplateI18nKey } from "../../constants/ledger-source-type";
import classes from "./journal.module.css";

/** Табаар ялгадаг эх сурвалжууд (дараалал нь таб ба хураангуйн зураасын дараалал). */
export const JOURNAL_TABS = ["INVOICE", "PAYMENT", "INVOICE_AMENDMENT", "REVERSAL", "MANUAL"] as const;

const PILL: Record<string, string> = {
  INVOICE: classes.pillInvoice,
  PAYMENT: classes.pillPayment,
  INVOICE_AMENDMENT: classes.pillAmend,
  REVERSAL: classes.pillReversal,
  MANUAL: classes.pillManual,
};

const DOT: Record<string, string> = {
  INVOICE: classes.dotInvoice,
  PAYMENT: classes.dotPayment,
  INVOICE_AMENDMENT: classes.dotAmend,
  REVERSAL: classes.dotReversal,
  MANUAL: classes.dotManual,
};

export const pillClass = (code: string) => PILL[code] ?? classes.pillOther;
export const dotClass = (code: string) => DOT[code] ?? classes.dotOther;

export function useSourceLabel() {
  const { t } = useTranslation("billing");
  return (code: string) => t(`ledger.source.${code}`, { defaultValue: code });
}

export function useTemplateLabel() {
  const { t } = useTranslation("billing");
  return (code: string | null | undefined) => {
    if (!code) return null;
    const label = t(`ledger.template.${postingTemplateI18nKey(code)}`, { defaultValue: "" });
    return label || code;
  };
}

/** Табын богино нэр (Залруулга), байхгүй бол бүтэн нэр. */
export function useShortSourceLabel() {
  const { t } = useTranslation("billing");
  const full = useSourceLabel();
  return (code: string) => t(`ledger.jrn.tabs.${code}`, { defaultValue: full(code) });
}

export function SourcePill({ code }: { code: string }) {
  const label = useShortSourceLabel()(code);
  return (
    <Text span className={`${classes.pill} ${pillClass(code)}`}>
      {label}
    </Text>
  );
}
